import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { translate } from "@sequentech/ui-core";
import { useTranslation } from "react-i18next";
import { SlateDialog } from "../SlateDialog/SlateDialog";
import { ESlateCoverageLabel, getSlateCoverageLabel } from "../../services/SlateCoverage";
var OfficeList = styled("ul")(function (_a) {
    var theme = _a.theme;
    return ({
        "listStyle": "none",
        "margin": "22px 0 0",
        "padding": 0,
        "overflowWrap": "anywhere",
        "& .slate-details-office": {
            padding: "12px 0",
            borderBottom: "1px solid #e7eaee",
        },
        "& .slate-details-office:last-of-type": {
            borderBottom: "none",
        },
        "& .slate-details-office-name": {
            display: "block",
            marginBottom: "5px",
            fontSize: "14px",
            fontWeight: 700,
        },
        "& .slate-details-candidate": {
            display: "block",
            fontSize: "14px",
            lineHeight: 1.5,
            color: theme.palette.customGrey.dark,
        },
    });
});
export var ESlateDetailsAction;
(function (ESlateDetailsAction) {
    ESlateDetailsAction["SELECT"] = "select";
    ESlateDetailsAction["EDIT"] = "edit";
    /** The slate cannot be selected on this ballot: only Back is offered. */
    ESlateDetailsAction["UNAVAILABLE"] = "unavailable";
})(ESlateDetailsAction || (ESlateDetailsAction = {}));
/** Every candidate of a slate, office by office, before selecting it. */
export var SlateDetailsDialog = function (_a) {
    var open = _a.open, slate = _a.slate, slateName = _a.slateName, action = _a.action, handleClose = _a.handleClose;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var candidates = slate.contests.reduce(function (total, entry) { return total + entry.candidates.length; }, 0);
    var contests = slate.contests.map(function (entry) { return entry.contest; });
    var coverage = (function () {
        var _a;
        if (!slate.coverage) {
            return undefined;
        }
        var _b = getSlateCoverageLabel(slate.coverage, contests), label = _b.label, contest = _b.contest;
        if (label === ESlateCoverageLabel.FULL) {
            return t("slates.coverage.full");
        }
        if (label === ESlateCoverageLabel.SINGLE_CONTEST && contest) {
            return t("slates.coverage.singleContest", {
                contest: (_a = translate(contest, "name", i18n.language)) !== null && _a !== void 0 ? _a : "",
            });
        }
        return t("slates.coverage.partial");
    })();
    var count = t("slates.coverage.candidates", { count: candidates });
    return (_jsxs(SlateDialog, { className: "slate-details-dialog", open: open, handleClose: handleClose, title: slateName, ok: action === ESlateDetailsAction.EDIT
            ? t("slates.selection.edit")
            : action === ESlateDetailsAction.SELECT
                ? t("slates.view.select")
                : undefined, cancel: t("slates.view.back"), children: [_jsx(Typography, { className: "slate-details-summary", sx: {
                    margin: "0 0 12px",
                    fontSize: "inherit",
                    lineHeight: "inherit",
                    color: "customGrey.dark",
                }, children: coverage ? t("slates.view.summary", { coverage: coverage, candidates: count }) : count }), _jsx(OfficeList, { className: "slate-details-offices", children: slate.contests.map(function (_a) {
                    var _b;
                    var contest = _a.contest, members = _a.candidates;
                    return (_jsxs("li", { className: "slate-details-office", "data-contest-id": contest.id, children: [_jsx("span", { className: "slate-details-office-name", children: (_b = translate(contest, "name", i18n.language)) !== null && _b !== void 0 ? _b : contest.id }), members.map(function (candidate) {
                                var _a;
                                return (_jsx("span", { className: "slate-details-candidate", children: (_a = translate(candidate, "name", i18n.language)) !== null && _a !== void 0 ? _a : candidate.id }, candidate.id));
                            })] }, contest.id));
                }) })] }));
};
